import {PayloadV2} from '../../../../../../core/service/payload/payloadV2';
import {AudioRecordSaveBusinessPayload} from './audioRecordSaveBusiness.payload';
import {AudioRecord} from "../../component/audio-recording/audio-recording.component";
import {BlobHelper} from "../../../../../../core/blob/blob.helper";
import {PayloadWithId} from "../../../../../../core/service/payload/payloadWithId";
import {PayloadWithSummary} from "../../../../../../core/service/payload/payloadWithSummary";

export class AudioRecordSavePayload extends PayloadWithSummary {
    name: string;
    categoryValue: string;
    contentValues: string[] = [];
    content: string;
    msDuration: number;
    deletable = true;
    partnerId: number;
    businessContext: AudioRecordSaveBusinessPayload;

    static fromRecord(record: AudioRecord, categoryValue: string): Promise<AudioRecordSavePayload> {
        return new Promise((resolve, reject) => {
            BlobHelper.blobToBase64(record.content).then((base64) => {
                resolve({
                    name: record.name,
                    categoryValue: categoryValue,
                    contentValues: record.contentValues,
                    content: base64.replace('data:audio/wav;base64,', ''),
                    msDuration: record.msDuration,
                    deletable: record.deletable,
                    partnerId: record.partnerId,
                    businessContext: undefined,
                    summary: {
                        id: undefined
                    }
                });
            });
        });
    }
}
